// Service Worker + Push Notifications helpers
import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const out = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) out[i] = rawData.charCodeAt(i);
    return out;
}

let swRegistration = null;
let registerPromise = null;

export function isPushSupported() {
    return (
        typeof window !== "undefined" &&
        "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window
    );
}

export function registerServiceWorker() {
    if (!isPushSupported()) return Promise.resolve(null);
    if (registerPromise) return registerPromise;
    registerPromise = navigator.serviceWorker
        .register("/sw.js")
        .then((reg) => {
            swRegistration = reg;
            return reg;
        })
        .catch((e) => {
            console.warn("SW register failed", e);
            registerPromise = null;
            return null;
        });
    return registerPromise;
}

export async function subscribeToPush(times = ["09:00", "17:00"]) {
    if (!isPushSupported()) throw new Error("Push non supportato dal browser");
    const reg = await registerServiceWorker();
    if (!reg) throw new Error("Service worker non disponibile");
    const { data: keyData } = await api.get("/push/vapid-public-key");
    if (!keyData.key) throw new Error("VAPID key non configurata");

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(keyData.key),
        });
    }
    const subJson = sub.toJSON();
    await api.post("/push/subscribe", {
        endpoint: subJson.endpoint,
        keys: subJson.keys,
        times,
        user_agent: navigator.userAgent.slice(0, 200),
    });
    return sub;
}

export async function updatePushTimes(times) {
    if (!isPushSupported()) return;
    const reg = await registerServiceWorker();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const subJson = sub.toJSON();
    await api.post("/push/subscribe", {
        endpoint: subJson.endpoint,
        keys: subJson.keys,
        times,
        user_agent: navigator.userAgent.slice(0, 200),
    });
}

export async function unsubscribeFromPush() {
    if (!isPushSupported()) return;
    const reg = await registerServiceWorker();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        try {
            await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
        } catch {}
        await sub.unsubscribe();
    }
}

export async function getPushStatus() {
    if (!isPushSupported()) return { supported: false };
    const reg = await registerServiceWorker();
    if (!reg) return { supported: true, registered: false };
    const sub = await reg.pushManager.getSubscription();
    return { supported: true, registered: true, subscribed: !!sub };
}

export async function sendTestPush() {
    const { data } = await api.post("/push/test", { title: "Samir HACCP", body: "Tutto funziona! 🌱" });
    return data;
}
